import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { MobileAddOnCustomize } from "./component";
import {
  fetchAncillaryOfferCallStateSelector,
  cfarAddOnChoicePropertiesSelector,
  isDisruptionProtectionAvailableSelector,
  isCfarAvailableSelector,
  dpAddOnChoicePropertiesSelector,
  cfarAttachPropertiesForViewBookingAddOnSelector,
  dpOfferPropertiesForViewBookingAddOnSelector,
  viewBookingAddOnPropertiesSelector,
  hasActiveRefundableFareInFlightShopSelector,
  cfarDiscountPropertiesSelector,
  cfarOfferSelector,
  selectedCfarIdSelector,
  selectedCfarOfferPricesSelector,
  disruptionProtectionOfferSelector,
  selectedDisruptionProtectionIdSelector,
  selectedDisruptionProtectionOfferPricesSelector,
  selectedDisruptionProtectionOfferProductVariantSelector,
} from "../../../reducer/selectors";
import { populateFlightBookQueryParams } from "../../../../book/actions/actions";
import {
  fetchAncillaryOffer,
  setSelectedCfarId,
  setSelectedDisruptionProtectionId,
} from "../../../actions/actions";
import { IStoreState } from "../../../../../reducers/types";
import { cfarSocialVariantSelector } from "../../../../ancillary/reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../rewards/reducer";
import { hasTravelFusionInSelectedTripDetailsSelector } from "../../../../book/reducer";

const mapStateToProps = (state: IStoreState) => ({
  fetchAncillaryOfferCallState: fetchAncillaryOfferCallStateSelector(state),
  cfarAddOnChoiceProperties: cfarAddOnChoicePropertiesSelector(state),
  dpAddOnChoiceProperties: dpAddOnChoicePropertiesSelector(state),
  isDisruptionProtectionAvailable:
    isDisruptionProtectionAvailableSelector(state),
  isCfarAvailable: isCfarAvailableSelector(state),
  viewBookingAddOnProperties: viewBookingAddOnPropertiesSelector(state),
  dpOfferPropertiesForViewBookingAddOn:
    dpOfferPropertiesForViewBookingAddOnSelector(state),
  cfarOfferPropertiesForViewBookingAddOn:
    cfarAttachPropertiesForViewBookingAddOnSelector(state),
  hasActiveRefundableFare: hasActiveRefundableFareInFlightShopSelector(state),
  cfarSocialVariant: cfarSocialVariantSelector(state),
  cfarDiscountProperties: cfarDiscountPropertiesSelector(state),
  cfarOffer: cfarOfferSelector(state),
  selectedCfarId: selectedCfarIdSelector(state),
  cfarOfferPrices: selectedCfarOfferPricesSelector(state),
  rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  hasTravelFusionFareBrand: hasTravelFusionInSelectedTripDetailsSelector(state),
  disruptionOffer: disruptionProtectionOfferSelector(state),
  selectedDisruptionProtectionId: selectedDisruptionProtectionIdSelector(state),
  disruptionProtectionOfferPrices:
    selectedDisruptionProtectionOfferPricesSelector(state),
  fdaProductVariant:
    selectedDisruptionProtectionOfferProductVariantSelector(state),
});

const mapDispatchToProps = {
  populateFlightBookQueryParams,
  fetchAncillaryOffer,
  setSelectedCfarId,
  setSelectedDisruptionProtectionId,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileAddOnCustomizeConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileAddOnCustomize = withRouter(
  connector(MobileAddOnCustomize)
);
